import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import LoadingBar from "react-top-loading-bar";
import { AssetSvg } from "../../assets";
import { AppConstants, PaginationSettings } from "../../configs";
import { useAppSelector, VRIAppStateType} from "../../core";
import { AdminPageTemplate, ColumnToolTip, ModalConfirmDelete, ModalSkill, } from "../../features";
import { ApiSchemaSkillData } from "../../models/api/skill";
import { useFunctionalityPagedSkill, useFunctionalitySkill } from "../hooks";

export function PageSkills(): JSX.Element {
  const [modalShow, setModalShow] = React.useState(false);
  const [deleteModalShow, setDeleteModalShow] = React.useState(false);

  const [loaderProgress, setLoaderProgress] = useState(0);
  const [dataToEdit, setDataToEdit] = React.useState<ApiSchemaSkillData | undefined>(undefined);
  const [dataToDelete, setDataToDelete] = useState<string[]>([]);

  const [searchText, setSearchText] = useState("");
  const [pageIndex, setPageIndex] = useState(
    PaginationSettings.initialPageIndex
  );
  const [pageSize, setPageSize] = useState(PaginationSettings.initialPageSize);
  const [hasPagingData, setHasPagingData] = useState<boolean>(false);

  const handleSearch = (e: any) => {
    ReactDOM.unstable_batchedUpdates(() => {
      setSearchText(e.target.value);
      setPageIndex(1);
    });
  };
  const onChangePageIndex = (index: number) => {
    setPageIndex(index);
  };
  const onChangePageSize = (size: number) => {
    setPageSize(size);
  };
  const data = useAppSelector((state: VRIAppStateType) => ({
    userRole: state.auth.profile?.userRole,
    companyId: state.auth.profile?.companyId
  }));
  const { onDeleteSkill } = useFunctionalitySkill();
  const { pagedSkillList, pagedSkillListCount } = useFunctionalityPagedSkill({
    CompanyId: data.userRole === AppConstants.UserRoles.ResellerAdmin ? data.companyId : "",
    pageSize: pageSize,
    pageNo: pageIndex,
    searchText: searchText?.trimStart(),
    setLoaderProgress,
  });

  useEffect(() => {
    if (pagedSkillList?.length > 0) {
      setHasPagingData(true);
    } else {
      setHasPagingData(false);
    }
  }, [pagedSkillList]);

  const onDeleteHandler = () => {
    onDeleteSkill(dataToDelete)
      .then(() => {
        setDeleteModalShow(false);
      })
      .catch((e) => console.error(e));
  };

  const skillsTableColumns = [
    {
      name: <ColumnToolTip data="Name" />,
      selector: (row: ApiSchemaSkillData) => {
        return <ColumnToolTip data={row.name} />;
      },
      maxWidth: "700px",
    },
    {
      name: <ColumnToolTip data="Pin" />,
      selector: (row: ApiSchemaSkillData) => {
        return <ColumnToolTip data={row.pin} />;
      },
    },
    {
      name: <ColumnToolTip data="Actions" />,
      allowOverflow: true,
      selector: (row: ApiSchemaSkillData) => {
        return (
          <>
            <div
              className="btn svg-color"
              title="Edit"
              onClick={() => {
                setDataToEdit(row);
                setModalShow?.(true);
              }}
            >
              <span >
                <AssetSvg.Edit />
              </span>
            </div>
            <div
              className="btn svg-color"
              title="Delete"
              onClick={() => {
                setDeleteModalShow?.(true);
                setDataToDelete((prev) => [...prev, row.id]);
              }}
            >
              <span >
                <AssetSvg.Delete />
              </span>
            </div>
          </>
        );
      },
      omit: data.userRole === AppConstants.UserRoles.Admin ? false : true,
    },
  ];

  return (
    <>
      <LoadingBar
        progress={loaderProgress}
        onLoaderFinished={() => setLoaderProgress(0)}
      />
      <AdminPageTemplate
        pagingKey="PageSkills"
        loaderProgress={loaderProgress}
        pageTitle="Skill"
        modalControlBtnLabel="Add Skill"
        tableHeaders={skillsTableColumns}
        tableData={pagedSkillList || []}
        setCreateModalShow={setModalShow}
        selectableRows={true}
        searchText={searchText}
        handleSearch={handleSearch}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        count={pagedSkillListCount}
        onChangePageIndex={onChangePageIndex}
        onChangePageSize={onChangePageSize}
        hasPagingData={hasPagingData}
        setHasPagingData={setHasPagingData}
      />
      <ModalSkill
        key={new Date() + ""}
        show={modalShow}
        handleShow={setModalShow}
        dataToEdit={dataToEdit}
        setDataToEdit={setDataToEdit}
      />
      <ModalConfirmDelete
        show={deleteModalShow}
        handleShow={setDeleteModalShow}
        deleteHandler={onDeleteHandler}
      />
    </>
  );
}
